import React from 'react';
import { Loader2 } from 'lucide-react';

interface LoadingProps {
    className?: string;
    message?: string;
}

const Loading: React.FC<LoadingProps> = ({
    className = "flex items-center justify-center min-h-screen",
    message = "Loading..."
}) => {
    return (
        <div className={className}>
            <div className="flex flex-col items-center space-y-2">
                <Loader2 className="h-8 w-8 animate-spin text-primary" />
                <p className="text-sm text-muted-foreground">{message}</p>
            </div>
        </div>
    );
};

export default Loading;
